import { Box, CssBaseline } from '@mui/material'
import NavBar from '@shared/components/layout/NavBar'
import Aside from '@shared/components/layout/Aside'
import Footer from '@shared/components/layout/Footer'
import PageBreadcrumbs from '@shared/components/layout/PageBreadcrumbs'
import { Outlet } from 'react-router'
import { useState, useEffect } from 'react'

const SIDEBAR_STORAGE_KEY = 'msi.sidebar.expanded'

const loadInitialExpanded = () => {
  try {
    const raw = localStorage.getItem(SIDEBAR_STORAGE_KEY)
    if (raw === null) return true // default: expanded
    return raw === 'true'
  } catch {
    return true
  }
}

export default function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [sidebarExpanded, setSidebarExpanded] = useState(loadInitialExpanded)

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, String(sidebarExpanded))
    } catch {
      /* ignore quota / privacy mode */
    }
  }, [sidebarExpanded])

  const toggleSidebar = () => setSidebarExpanded((v) => !v)

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <CssBaseline />
      <Aside
        mobileOpen={mobileOpen}
        handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
        expanded={sidebarExpanded}
        onToggleExpand={toggleSidebar}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0, overflow: 'hidden' }}>
        <NavBar
          handleDrawerToggle={() => setMobileOpen(!mobileOpen)}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            overflowY: 'auto',
            p: 3,
          }}
        >
          <PageBreadcrumbs />
          <Outlet />
          <Footer sx={{ textAlign: 'center', py: 2, mt: 4 }} />
        </Box>
      </Box>
    </Box>
  )
}